// (function () {
//   // 1) Force hide Sobefy accessories modal
//   const style = document.createElement('style');
//   style.textContent = `
//     #sobefy__accesories-upsell-modal-popup,
//     #sobefy__accesories-upsell-modal {
//       display: none !important;
//       visibility: hidden !important;
//       opacity: 0 !important;
//     }
//   `;
//   document.head.appendChild(style);

//   // 2) Handle redirect AFTER add-to-cart happens
//   document.addEventListener('product:added', function (event) {
//     const lightboxContainer = document.getElementById("sobefy__accesories-upsell-modal");
//     const popupModal = document.getElementById("sobefy__accesories-upsell-modal-popup");

//     if (lightboxContainer) {
//       lightboxContainer.style.display = "none";
//       lightboxContainer.style.visibility = "hidden";
//       lightboxContainer.style.opacity = "0";
//     }

//     if (popupModal) {
//       popupModal.style.display = "none";
//       popupModal.style.visibility = "hidden";
//       popupModal.style.opacity = "0";
//     }

//     var context = window.__lastAddToCartContext || null;
//     if (context && context.expires <= Date.now()) {
//       window.__lastAddToCartContext = null;
//       context = null;
//     }

//     var isFromAccessories = false;
//     var isFromSample = false;

//     if (event.detail && event.detail.fromAccessories === true) {
//       isFromAccessories = true;
//     } else if (event.detail && event.detail.button) {
//       var b1 = event.detail.button;
//       if (b1.closest && b1.closest('.accessories_upsell')) isFromAccessories = true;
//     } else if (context && context.preventRedirect) {
//       isFromAccessories = true;
//     }

//     if (event.detail && event.detail.fromSample === true) {
//       isFromSample = true;
//     } else if (event.detail && event.detail.button) {
//       var b2 = event.detail.button;
//       if (b2.hasAttribute && (b2.hasAttribute('data-is-sample') || b2.hasAttribute('data-sample-order'))) {
//         isFromSample = true;
//       }
//     } else if (window.__isSampleOrder === true || window.__preventCartRedirect === true) {
//       isFromSample = true;
//     }

//     if (isFromAccessories || isFromSample) {
//       window.__lastAddToCartBtn = null;
//       window.__isSampleOrder = false;
//       window.__preventCartRedirect = false;
//       return;
//     }

//     var href = window.location.href;
//     var alreadyOnAddedPage =
//       href.indexOf('/pages/add-to-cart') !== -1 ||
//       href.indexOf('view=added-to-cart') !== -1;

//     if (alreadyOnAddedPage) return;

//     var btn = event.detail && event.detail.button ? event.detail.button : null;

//     var withAccessoriesUrl = '/pages/add-to-cart?view=added-to-cart';
//     var noAccessoriesUrl = '/cart';

//     if (btn && btn.dataset) {
//       if (btn.dataset.redirectWithAccessories) withAccessoriesUrl = btn.dataset.redirectWithAccessories;
//       if (btn.dataset.redirectNoAccessories) noAccessoriesUrl = btn.dataset.redirectNoAccessories;
//     }

//     var hasAccessories = false;
//     if (btn && btn.dataset && typeof btn.dataset.hasAccessories !== 'undefined') {
//       hasAccessories = (btn.dataset.hasAccessories === 'true');
//     }

//     window.location.href = hasAccessories ? withAccessoriesUrl : noAccessoriesUrl;
//   });

//   // 3) Intercept clicks and add via AJAX, then trigger product:added
//   document.addEventListener('click', function (e) {
//     var btn = e.target.closest(
//       'button.product-form__add-button[data-action="add-to-cart"], button.product-item__action-button[data-action="add-to-cart"]'
//     );
//     if (!btn) return;

//     var form = btn.closest('form');
//     if (!form) return;

//     var idInput = form.querySelector('input[name="id"]');
//     var quantityInput = form.querySelector('[name="quantity"]');

//     var variantId = idInput && idInput.value ? Number(idInput.value) : null;
//     var quantity = Math.max(1, parseInt((quantityInput && quantityInput.value) || '1', 10) || 1);

//     if (!variantId || !isFinite(variantId)) return;

//     var isFromAccessories = !!btn.closest('.accessories_upsell');

//    var isQuoteButton =
//   btn.classList.contains('sobefy-quote-button') ||
//   btn.id === 'order-quote-button' ||
//   btn.innerText.trim().toLowerCase().includes('quote');

// if (isQuoteButton) {
//   sessionStorage.setItem('quoteClickedSession', 'true');
//   sessionStorage.removeItem('pickupClicked');
// }
//     var isFromSample =
//       btn.hasAttribute('data-is-sample') ||
//       btn.hasAttribute('data-sample-order') ||
//       window.__isSampleOrder === true ||
//       window.__preventCartRedirect === true;

//     var context = {
//       preventRedirect: isFromAccessories || isFromSample,
//       expires: Date.now() + 5000
//     };

//     window.__lastAddToCartBtn = btn;
//     window.__lastAddToCartContext = context;

//     if (window.__lastAddToCartContextCleanupTimer) clearTimeout(window.__lastAddToCartContextCleanupTimer);
//     window.__lastAddToCartContextCleanupTimer = setTimeout(function () {
//       window.__lastAddToCartContext = null;
//     }, 5000);

//     e.preventDefault();
//     e.stopPropagation();

//     btn.disabled = true;
//     var originalText = btn.textContent;
//     btn.textContent = 'Adding…';

//     var beforeAdd = Promise.resolve();

//     if (isQuoteButton) {
//       beforeAdd = fetch('/cart/update.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json'
//         },
//         credentials: 'same-origin',
//         body: JSON.stringify({
//           attributes: {
//             quote_mode: 'true'
//           }
//         })
//       });
//     }

//     beforeAdd
//       .then(function () {
//         return fetch('/cart/add.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             'Accept': 'application/json',
//             'X-Requested-With': 'XMLHttpRequest'
//           },
//           credentials: 'same-origin',
//           body: JSON.stringify({ id: variantId, quantity: quantity })
//         });
//       })
//       .then(function (res) {
//         if (!res.ok) return res.json().then(function (j) { throw j; });
//         return res.json();
//       })
//       .then(function (payload) {
//         btn.textContent = 'Added';
//         setTimeout(function () {
//           btn.textContent = originalText;
//           btn.disabled = false;
//         }, 800);

//         if (context && payload && payload.product_id) {
//           context.variant = payload;
//         }

//         document.documentElement.dispatchEvent(
//           new CustomEvent('product:added', {
//             bubbles: true,
//             detail: {
//               quantity: quantity,
//               variant: payload,
//               button: btn,
//               fromAccessories: isFromAccessories,
//               fromSample: isFromSample
//             }
//           })
//         );
//       })
//       .catch(function () {
//         btn.textContent = 'Try again';
//         setTimeout(function () {
//           btn.textContent = originalText;
//           btn.disabled = false;
//         }, 1200);

//         window.__lastAddToCartContext = null;
//         window.__lastAddToCartBtn = null;
//       });
//   });
// })();

(function () {
  if (window.__fcRedirectHandlerInstalled === true) {
    return;
  }

  window.__fcRedirectHandlerInstalled = true;

  // Hide Sobefy accessories modal
  var style = document.createElement('style');

  style.textContent = `
    #sobefy__accesories-upsell-modal-popup,
    #sobefy__accesories-upsell-modal {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
    }
  `;

  document.head.appendChild(style);

  // Redirect only after theme.js successfully adds the product
  document.addEventListener('product:added', function (event) {
    var detail = event.detail || {};
    var btn = detail.button || null;

    var lightboxContainer =
      document.getElementById(
        'sobefy__accesories-upsell-modal'
      );

    var popupModal =
      document.getElementById(
        'sobefy__accesories-upsell-modal-popup'
      );

    if (lightboxContainer) {
      lightboxContainer.style.display = 'none';
      lightboxContainer.style.visibility = 'hidden';
      lightboxContainer.style.opacity = '0';
    }

    if (popupModal) {
      popupModal.style.display = 'none';
      popupModal.style.visibility = 'hidden';
      popupModal.style.opacity = '0';
    }

    var context =
  window.__lastAddToCartContext || null;

if (
  context &&
  context.expires &&
  context.expires <= Date.now()
) {
  window.__lastAddToCartContext = null;
  context = null;
}

var isFromAccessories =
  detail.fromAccessories === true ||
  (
    btn &&
    btn.closest &&
    btn.closest('.accessories_upsell')
  );

var isFromSample =
  detail.fromSample === true ||
  (
    btn &&
    btn.hasAttribute &&
    (
      btn.hasAttribute('data-is-sample') ||
      btn.hasAttribute('data-sample-order')
    )
  ) ||
  window.__isSampleOrder === true ||
  window.__preventCartRedirect === true;

var shouldPreventRedirect =
  context &&
  context.preventRedirect === true;

if (
  isFromAccessories ||
  isFromSample ||
  shouldPreventRedirect
) {
  window.__lastAddToCartContext = null;
  window.__lastAddToCartBtn = null;
  window.__isSampleOrder = false;
  window.__preventCartRedirect = false;

  return;
}

    var currentUrl = window.location.href;

    if (
      currentUrl.indexOf('/pages/add-to-cart') !== -1 ||
      currentUrl.indexOf('view=added-to-cart') !== -1
    ) {
      return;
    }

    var withAccessoriesUrl =
      '/pages/add-to-cart?view=added-to-cart';

    var noAccessoriesUrl = '/cart';

    if (btn && btn.dataset) {
      if (btn.dataset.redirectWithAccessories) {
        withAccessoriesUrl =
          btn.dataset.redirectWithAccessories;
      }

      if (btn.dataset.redirectNoAccessories) {
        noAccessoriesUrl =
          btn.dataset.redirectNoAccessories;
      }
    }

    var hasAccessories =
      btn &&
      btn.dataset &&
      btn.dataset.hasAccessories === 'true';

    window.location.href = hasAccessories
      ? withAccessoriesUrl
      : noAccessoriesUrl;
  });
})();